import React from "react";
import { Lightbulb, SlidersHorizontal, Network } from "lucide-react";

function Value() {
  return (
    <section
      id="about"
      className="bg-background text-foreground font-light px-6 md:px-[75px] py-[75px]"
    >
      <div className="mx-auto">
        <h2 className="text-4xl md:text-5xl leading-tight text-left mb-12">
          What Sets Us Apart<span className="text-brand">.</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
            <Lightbulb className="h-8 w-8 text-brand mb-4" />
            <h3 className="text-xl font-medium mb-2 text-foreground">
              Strategic Consulting
            </h3>
            <p className="text-sm text-muted-foreground">
              Unlike traditional consultants who offer templated solutions, we
              begin with a full diagnostic to ensure cultural alignment,
              scalability and cost efficiency. Our strategic consulting
              engagements are tailored to your organization’s goals, operational
              complexity and stage of maturity.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
            <SlidersHorizontal className="h-8 w-8 text-brand mb-4" />
            <h3 className="text-xl font-medium mb-2 text-foreground">
              Managed Services
            </h3>
            <p className="text-sm text-muted-foreground">
              We provide ongoing performance management across the entire
              payments stack — from routing logic and BIN mapping to chargeback
              mitigation and shopper experience. Our team partners directly with
              your internal resources to maximize approval rates and customer
              lifetime value, while minimizing chargebacks and customer support
              issues.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
            <Network className="h-8 w-8 text-brand mb-4" />
            <h3 className="text-xl font-medium mb-2 text-foreground">
              Industry Network & Partner Enablement
            </h3>
            <p className="text-sm text-muted-foreground">
              Our curated network includes leading banks, payment processors,
              technology platforms and subject-matter experts. We connect you to
              the right partners at the right time — eliminating guesswork and
              accelerating outcomes through trusted relationships and proven
              solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Value;
